import React, { useEffect, useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Typography,
  StepIcon,
  Box,
  Paper,
  Button,
} from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { showAlert } from "../../../actions/alert";
import { useDispatch, useSelector } from "react-redux";
import { getLatestStatusDetailsById } from "../../../api/resignation";
import { handleAxiosError } from "../../../config/action-config";
import { CheckCircle } from "@mui/icons-material";

// const CustomStepIcon = styled(StepIcon)({
//   color: "#1976d3",
// });

const ProgressSteps = ({ data ,lastWorkingDay}) => {
  const [latestStatus, setLatestStatus] = useState("");
  const [employeeId, setEmployeeId] = useState(data[0]?.emp_id);
  const EmpId = localStorage.getItem("EmpId");

  useEffect(() => {
    if (EmpId) {
      getLatestStatus();
      // setEmployeeId(data[0]?.emp_id);
    } else {
      navigate("/resignation-request");
    }
  }, [employeeId]);

  async function getLatestStatus() {
    try {
      const { data } = await getLatestStatusDetailsById(
        EmpId || employeeId,
        user.token
      );
      setLatestStatus(data.data[0].status_details);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const params = useParams();

  const navigate = useNavigate();
  const handleStepClick = (index, status) => {
    switch (status.status_details) {
      case "RESIGNATION ACCEPTED": {
        if (status.ktflag !== 0) {
          navigate(`/resignation-checklist/${params.id}/RESIGNATION ACCEPTED`, {
            state: { employeeId: data[0].emp_id },
          });
        } else if (
          status.ktflag === 0 &&
          latestStatus === "RESIGNATION ACCEPTED"
        ) {
          navigate(`/resignation-checklist/${params.id}/RESIGNATION ACCEPTED`, {
            state: { employeeId: data[0].emp_id },
          });
        }
        break;
      }
      case "KT_ASSIGNED": {
        if (latestStatus === status.status_details) {
          navigate(`/resignation-checklist/${params.id}/KT_ASSIGNED`, {
            state: { employeeId: data[0].emp_id },
          });
        }

        break;
      }
      case "KT_SUBMITTED": {
        navigate(`/resignation-checklist/${params.id}/KT_SUBMITTED`, {
          state: { employeeId: data[0].emp_id },
        });
        break;
      }
      case "KT_APPROVED": {
        if (status.ktflag !== 0) {
          if (latestStatus === status.status_details) {
            navigate(
              `/resignation-checklist/${params.id}/CREDENTIALS_CHECKLIST_APPROVED`,
              {
                state: { employeeId: data[0].emp_id },
              }
            );
          } else {
            navigate(`/resignation-checklist/${params.id}/KT_APPROVED`, {
              state: { employeeId: data[0].emp_id },
            });
          }
        } else if (status.ktflag === 0 && latestStatus === "KT_APPROVED") {
          navigate(
            `/resignation-checklist/${params.id}/CREDENTIALS_CHECKLIST_APPROVED`,
            {
              state: { employeeId: data[0].emp_id },
            }
          );
        }
        break;
      }
      case "CREDENTIALS_CHECKLIST_APPROVED": {
        // if (status.assetflag !== 0) {

        if (
          (latestStatus === status.status_details && user.role === "Admin") ||
          user.department == "HR"
        ) {
          navigate(`/assets-checklist/${data[0].emp_id}/ASSET_SUBMITTED`, {
            state: { employeeId: data[0].emp_id ,lastWorkingDay:lastWorkingDay},
          });
        } else {
          navigate(
            `/resignation-checklist/${params.id}/CREDENTIALS_CHECKLIST_APPROVED`,
            {
              state: { employeeId: data[0].emp_id },
            }
          );
        }

        // } else if (
        //   status.assetflag === 0 &&
        //   latestStatus === "CREDENTIALS_CHECKLIST_APPROVED"
        // ) {
        //   navigate(`/assets-checklist/${data[0].emp_id}/ASSET_SUBMITTED`, {
        //     state: { employeeId: data[0].emp_id, resignationId: resignationId },
        //   });
        // }
        break;
      }
      case "ASSET_SUBMITTED": {
        if (user.role === "Admin" || user.department == "HR") {
          if (status.assetflag !== 0) {
            console.log("p1");

            console.log("p2");
            if (latestStatus === status.status_details) {
              navigate(`/FNF-process/${data[0].emp_id}/ASSET_SUBMITTED`, {
                state: { employeeId: data[0].emp_id },
              });
            } else {
              navigate(`/assets-checklist/${data[0].emp_id}/ASSET_SUBMITTED`, {
                state: { employeeId: data[0].emp_id },
              });
            }
          } else if (
            status.assetflag === 0 &&
            latestStatus === "ASSET_SUBMITTED"
          ) {
            console.log("p3");
            navigate(`/FNF-process/${data[0].emp_id}/ASSET_SUBMITTED`, {
              state: { employeeId: data[0].emp_id },
            });
          }
        } else {
          if (latestStatus !== "EXIT_COMPLETED") {
            dispatch(
              showAlert("Further process will be done or review by admin & HR.")
            );
          }
        }
        break;
      }
      case "EXIT_COMPLETED": {
        if (user.role === "Admin" || user.department == "HR") {
          navigate(`/FNF-process/${data[0].emp_id}/ASSET_SUBMITTED`, {
            state: { employeeId: data[0].emp_id },
          });
        } else {
          if (latestStatus !== "EXIT_COMPLETED") {
            dispatch(
              showAlert("Further process will be done or review by admin & HR.")
            );
          }
        }
        break;
      }
      // case "ASSET_SUBMITTED": {
      //   navigate(`/assets-checklist/${data[0].emp_id}/ASSET_SUBMITTED`, {
      //     state: { employeeId: data[0].emp_id },
      //   });
      //   break;
      // }
      default:
        break;
    }
  };

  return (
    <Box p={0.5}>
      {/* <Typography variant="h6" gutterBottom>
        Employee Resignation Status
      </Typography>
      <br /> */}
      <Stepper>
        {data.map((status, index) => (
          <Step
            key={status.id}
            completed={status.status_details === "EXIT_COMPLETED"}
          >
            <StepLabel StepIconComponent={CustomStepIcon}>
              <Button onClick={() => handleStepClick(index, status)}>
                <div
                  variant="body1"
                  style={{
                    fontSize: "0.6rem",
                    color:
                      status.status_details === "EXIT_COMPLETED"
                        ? "#14f00c"
                        : "#0c23f0",
                  }}
                >
                  {status.status_details.replace(/_/g, " ")}
                </div>
              </Button>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

function CustomStepIcon(props) {
  const { active, completed } = props;

  // Change the icon based on completion status
  if (completed) {
    return <CheckCircle style={{ color: "#14f00c" }} />; // Use CheckCircleIcon for completed steps
  } else {
    return <CheckCircle style={{ color: "#0c23f0" }} />; // Use default icon for other steps
  }
}

export default ProgressSteps;
